import { useEffect, useState } from "react";
import { Button, Caption1, Card, Text, CardHeader, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { DismissRegular, DocumentRegular, FolderRegular, DocumentMultipleRegular } from "@fluentui/react-icons";
import { IItemCardProps } from "./item-card.props";

const layoutStyles = makeStyles({
    mainWrapper: {
        ...shorthands.borderWidth('1px'),
        ...shorthands.borderStyle('solid'),
        ...shorthands.borderColor(tokens.colorNeutralStrokeSubtle),
        ...shorthands.padding('5px'),
        display: 'flex'
    },
    image: {
        width: '28px'
    },
    textWrapper: {
        ...shorthands.overflow('hidden'),
        display: 'inline-grid',
        '> span': {
            display: 'block',
            ...shorthands.overflow('hidden'),
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }
});

export default function ItemCard(props: IItemCardProps) {
    const styles = layoutStyles();
    const [itemIcon, setItemIcon] = useState<JSX.Element>();

    useEffect(() => {
        // SharedObjectType: File=1, Folder=2, default for others
        switch (props.item.itemType) {
            case 1: // File
                setItemIcon(<DocumentRegular fontSize={28} />);
                break;
            case 2: // Folder
                setItemIcon(<FolderRegular fontSize={28} />);
                break;
            default:
                setItemIcon(<DocumentMultipleRegular fontSize={28} />);
                break;
        }
    }, [props.item.itemType]);

    const onClick = () => {
        console.log(`ItemCard -> onClick -> `, props.item);
        if (props.onSelect)
            props.onSelect(props.item);
    }

    const onDismissClick = () => {
        console.log(`ItemCard -> onDismissClick -> `, props.item);
        if (props.onDismissClick)
            props.onDismissClick(props.item);
    }

    return (
        <Card onClick={props.onSelect ? onClick : undefined} appearance={props.style}>
            <CardHeader
                image={itemIcon}
                header={<div className={styles.textWrapper}><Text as="span">{props.item.itemName}</Text></div>}
                description={<div className={styles.textWrapper}><Caption1 as="span">{props.item.itemUrl}</Caption1></div>}
                action={props.onDismissClick && <Button onClick={onDismissClick} appearance="subtle" icon={<DismissRegular />} />}
            />
        </Card>
    );
}